export const converToThaiNumber = (num) => {
  const array = {
    1: "๑",
    2: "๒",
    3: "๓",
    4: "๔",
    5: "๕",
    6: "๖",
    7: "๗",
    8: "๘",
    9: "๙",
    0: "๐",
  };

  let str = num?.toString();
  for (const val in array) {
    str = str?.split(val)?.join(array[val]);
  }
  return str;
};

export const parseDate = (dateStr) => {
  const [dateparts, timeparts] = dateStr.split(" ");
  const [year, month, day] = dateparts.split("-");
  const [hours = 0, minutes = 0, seconds = 0] = timeparts?.split(":") ?? [];
  // Treats the string as UTC, but you can remove the `Date.UTC` part and use
  // `new Date` directly to treat the string as local time
  return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
};

export const convertDateToString = (value) => {
  if (!value) return;

  const nDate = parseDate(value);

  let ye = nDate.getFullYear() + 543;
  let mo = nDate.getMonth() + 1;
  let da = nDate.getDate();

  if (+da < 10) {
    da = "0" + da;
  }

  if (+mo < 10) {
    mo = "0" + mo;
  }

  return ` ${da}/${mo}/${ye}`;
  // return value;
};

export const convertDateToString2 = (value) => {
  if (!value) return;

  let ye = value.split("/")[2];
  let mo = value.split("/")[0];
  let da = value.split("/")[1];

  if (+da < 10) {
    da = "0" + da;
  }

  if (+mo < 10) {
    mo = "0" + mo;
  }

  return ` ${da}/${mo}/${ye}`;
  // return value;
};

export const convertDateThai = (value, thaiDate) => {
  if (!value) return;

  const nDate = parseDate(value);

  let ye = nDate.getFullYear() + 543;
  let mo = nDate.getMonth();
  let da = nDate.getDate();

  // if (+da < 10) {
  //   da = "0" + da;
  // }

  const month = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  return ` ${thaiDate ? converToThaiNumber(da) : da} ${month[mo]} พ.ศ. ${
    thaiDate ? converToThaiNumber(ye) : ye
  }`;
};

export const convertDateThai2 = (nDate, thaiDate) => {
  if (!nDate) return;

  let ye = nDate.getFullYear() + 543;
  let mo = nDate.getMonth();
  let da = nDate.getDate();

  // if (+da < 10) {
  //   da = "0" + da;
  // }

  const month = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  return ` ${thaiDate ? converToThaiNumber(da) : da} ${month[mo]} พ.ศ. ${
    thaiDate ? converToThaiNumber(ye) : ye
  }`;
};

export const convertTime = (value, prefix, suffix) => {
  if (!value) return;
  const nDate = parseDate(value);

  let h = nDate.getHours();
  let m = nDate.getMinutes();

  if (+h < 10) {
    h = "0" + h;
  }

  if (+m < 10) {
    m = "0" + m;
  }

  return `${prefix ?? ""} ${h} : ${m} ${suffix ?? ""}`;
};

export const timeSince = (date, thai) => {
  let seconds = Math.floor((new Date() - parseDate(date)) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    let suffix = thai ? " ปี" : " years ago";

    return Math.floor(interval) + suffix;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    let suffix = thai ? " เดือน " : " months  ";
    let suffix2 = "";
    let interval2 = (seconds - Math.floor(interval) * 2592000) / 86400;
    if (interval2 > 0) {
      suffix2 = Math.floor(interval2) + (thai ? " วัน " : " days ago");
    }

    return Math.floor(interval) + suffix + suffix2;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    let suffix = thai ? " วัน" : " days ago";
    return Math.floor(interval) + suffix;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    let suffix = thai ? " ชั่วโมง" : " hours ago";
    return Math.floor(interval) + suffix;
  }
  interval = seconds / 60;
  if (interval > 1) {
    let suffix = thai ? " นาที" : " minutes ago";

    return Math.floor(interval) + suffix;
  }
  let suffix = thai ? " วินาที" : " seconds ago";

  return Math.floor(seconds) + suffix;
};

export const timeRemain = (date, thai) => {
  let seconds = Math.floor((parseDate(date) - new Date()) / 1000) + 86400;

  let interval = seconds / 31536000;

  if (interval > 1) {
    let suffix = thai ? " ปี" : " years ago";

    return Math.floor(interval) + suffix;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    let suffix = thai ? " เดือน " : " months  ";
    let suffix2 = "";
    let interval2 = (seconds - Math.floor(interval) * 2592000) / 86400;
    if (interval2 > 0) {
      suffix2 = Math.floor(interval2) + (thai ? " วัน " : " days ago");
    }

    return Math.floor(interval) + suffix + suffix2;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    let suffix = thai ? " วัน" : " days ago";
    return Math.floor(interval) + suffix;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    let suffix = thai ? " ชั่วโมง" : " hours ago";
    return Math.floor(interval) + suffix;
  }
  interval = seconds / 60;
  if (interval > 1) {
    let suffix = thai ? " นาที" : " minutes ago";

    return Math.floor(interval) + suffix;
  }
  let suffix = thai ? " วินาที" : " seconds ago";

  return Math.floor(seconds) + suffix;
};

export function dateDiff(dt1, dt2) {
  const date1 = new Date(dt1);
  const date2 = new Date(dt2);

  date1.setHours(0);
  date1.setMinutes(0, 0, 0);
  date2.setHours(0);
  date2.setMinutes(0, 0, 0);
  let datediff = Math.abs(date1.getTime() - date2.getTime()); // difference
  return parseInt(datediff / (24 * 60 * 60 * 1000), 10); //Convert values days and return value
}

export const matchOptions = (options, value = "") => {
  const match = options.find((item) => String(item.value) === String(value));

  return match ? match.label : "-";
};

export const changePrefixName = (name, prefix = "คุณ") => {
  if (
    name?.startsWith("นางสาว") ||
    name?.startsWith("นาง") ||
    name?.startsWith("นาย") ||
    name?.startsWith("คุณ")
  ) {
    return name
      .replace("นางสาว", prefix)
      .replace("นาง", prefix)
      .replace("นาย", prefix);
  } else {
    return `${prefix}${name}`;
  }
};

export function addDays(date, days) {
  var result = parseDate(date);
  result.setDate(result.getDate() + days);
  return result;
}
